// Editor tool types
export type Tool = 'select' | 'text' | 'rectangle' | 'ellipse' | 'image';

// Editor local state (not in Zustand store)
export interface EditorLocalState {
  activeTool: Tool;
  zoom: number;
  pan: { x: number; y: number };
  isLoading: boolean;
  error: string | null;
}

// Element properties for the properties panel
export interface ElementProperties {
  id: string;
  type: 'image' | 'text' | 'shape';
  x: number;
  y: number;
  width: number;
  height: number;
  rotation: number;
  opacity: number;
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
  // Text-specific
  content?: string;
  fontSize?: number;
  fontFamily?: string;
  textAlign?: 'left' | 'center' | 'right';
  // Image-specific
  src?: string;
  // Shape-specific
  shapeType?: 'rect' | 'ellipse';
}

// Default tool
export const DEFAULT_TOOL: Tool = 'select';

// Default zoom
export const DEFAULT_ZOOM = 1;
export const MIN_ZOOM = 0.25;
export const MAX_ZOOM = 4;
export const ZOOM_STEP = 0.25;

// Tool keyboard shortcuts
export const TOOL_SHORTCUTS: Record<string, Tool> = {
  v: 'select',
  t: 'text',
  r: 'rectangle',
  e: 'ellipse',
  i: 'image',
};

// Tool labels for UI
export const TOOL_LABELS: Record<Tool, string> = {
  select: 'Select',
  text: 'Text',
  rectangle: 'Rectangle',
  ellipse: 'Ellipse',
  image: 'Image',
};

// Tool icons (SVG path data)
export const TOOL_ICONS: Record<Tool, string> = {
  select: 'M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z', // Cursor arrow
  text: 'M5 4v3h5.5v12h3V7H19V4H5z', // Text T
  rectangle: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z', // Rectangle outline
  ellipse: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z', // Circle outline
  image: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z', // Image icon
};
